import { useNavigate } from "@tanstack/react-router"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useCreateGmailIntegrationMutation } from "modules/settings/hooks/gmail/useCreateGmailIntegrationMutation"
import { Loading } from "modules/shared/components/Loading"
import { useCallback, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { Route as AddGmailIntegrationRoute } from "routes/_base/_auth/settings/channels/gmail/new"

export const AddGmailIntegration = () => {
  const hasAlreadyValidated = useRef(false)
  const { t } = useTranslation()
  const { code, error } = AddGmailIntegrationRoute.useSearch()
  const navigate = useNavigate()
  const { mutateAsync } = useCreateGmailIntegrationMutation()

  const onOpenChange = useCallback(
    (isOpen: boolean = false) => {
      if (!isOpen) {
        navigate({ to: "/settings/channels/gmail", replace: true })
      }
    },
    [navigate],
  )

  useEffect(() => {
    if (!hasAlreadyValidated.current) {
      hasAlreadyValidated.current = true
      if (error === "access_denied" || code === "access_denied" || !code) {
        onOpenChange(false)
        return
      }

      mutateAsync({ code })
        .then(() => {
          onOpenChange(false)
        })
        .catch(() => onOpenChange(false))
    }
  }, [mutateAsync, code, error, hasAlreadyValidated, onOpenChange])

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.gmail.addIntegration.title")}</DialogTitle>
          <DialogDescription>
            {t("settings.integrations.gmail.addIntegration.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <Loading size={6} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
